import React from "react";
import { useStyles } from "./style";

const Wait = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <br />
      <img src="/waiting.svg" />
      <br />
    </div>
  );
};

export default Wait;
